import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { environment } from "../../../../../environments/environment";
import { MatBottomSheet } from '@angular/material/bottom-sheet';
import { MatSnackBar } from '@angular/material/snack-bar';

@Injectable({
  providedIn: 'root'
})
export class WebsiteMarketingServiceService {

  constructor(
    public dialog: MatDialog,
    private http: HttpClient,
    private _bottomSheet: MatBottomSheet,
    private snackbar: MatSnackBar,
    private router: Router,
  ) {

  }

  /** Navigate to the AI Writer micro-frontend (iframe shell at /admin/ai-writer). */
  navigateToAiWriter(queryParams?: Record<string, string | number | boolean>): void {
    void this.router.navigate(['admin', 'ai-writer'], {
      queryParams: queryParams && Object.keys(queryParams).length ? queryParams : undefined,
    });
  }
  openSocialBrand(componentName: any, height: any, width: any, data: any, maxWidth: string = '95vw', maxHeight: string = '90vh') {
    return this.dialog.open(componentName, {
      height: height,
      width: width,
      data: data,
      maxWidth: maxWidth,
      maxHeight: maxHeight
    });
  }
  filterDialog(componentName: any, panelClass: string, height: any, width: any, data: any, maxWidth: string = '95vw', maxHeight: string = '90vh') {
    return this.dialog.open(componentName, {
      panelClass: panelClass,
      height: height,
      width: width,
      data: data,
      maxWidth: maxWidth,
      maxHeight: maxHeight
    });
  }

  openPost(componentName: any, height: any, width: any, maxwidth: any, data: any, panelClass?: string) {
    return this.dialog.open(componentName, {
      height: height,
      width: width,
      maxWidth: maxwidth,
      data: data,
      panelClass: panelClass
    })
  }
  openPostComponent(componentName: any, height: any, width: any, maxwidth: any, maxheight: any, data: any) {
    return this.dialog.open(componentName, {
      height: height,
      width: width,
      maxWidth: maxwidth,
      maxHeight: maxheight,
      data: data,
    })
  }
  openBottomSheet(componentName: any, data: any) {
    return this._bottomSheet.open(componentName, {
      data: data,

    });
  }

  getFacebookUserPagesList(userId: string, userToken: string, socialMedia: string) {
    return this.http.get(environment.serverIp + `pages?userId=${userId}&channel=${socialMedia}`, { headers: { userToken: userToken } });
  }

  getSocialChannelPagesList(payload: any) {
    return this.http.put(environment.newServerIp + `social/get-account`, payload);
  }

  connectSelectedPagesToSocialMedia(pagesDetails: any) {
    return this.http.post(environment.newServerIp + `social/connect-account`, pagesDetails)
  }

  getAllConnectedPages(businessId: any) { // userId is UUID
    return this.http.get(environment.newServerIp + `social/${businessId}/accounts`);
  }

  getAllPostByPagesId(businessId: string, pageId: string | null, post_status: string, pageNo: number = 0, size: number = 0, sDate?: string, eDate?: string, channel?: string) {

    let url = "";
    if (pageId == 'AllPages')
      pageId = null
    if (pageId)
      url += `&pageId=${pageId}`;
    if (post_status)
      url += `&post_status=${post_status}`
    if (channel)
      url += `&accountId=${channel}`
    return this.http.get(environment.newServerIp + `post/listing?businessId=${businessId}&pageNo=${pageNo}&size=${size}&${url}&sDate=${sDate}&eDate=${eDate}`)
  }

  getPostStatus(postId: any) {
    return this.http.get(
      environment.newServerIp + `post/${postId}`, {}
    )
  }

  postOpenAiSuggestMarketing(data: any) {
    return this.http.post(
      environment.serverIp + `open-ai/integration/suggest/marketing`, data
    )
  }

  getHastTags(data: any) {
    return this.http.post(
      environment.serverIp + `open-ai/integration/suggest/marketing/post/hashtags`, data
    )
  }

  createHashtagGroup(data: any) {
    return this.http.post(
      environment.serverIp + `idea/hashtag`, data
    )
  }

  deleteHashTag(id: any) {
    return this.http.delete(
      environment.serverIp + `idea/hashtag/delete?hashTagId=${id}`
    )
  }

  getAllHashtag(businessId: any) {
    return this.http.get(
      environment.serverIp + `idea/hashtag/get?businessId=${businessId}`
    )
  }

  createTag(data: any) {
    return this.http.post(
      environment.newServerIp + `tag`, data
    )
  }

  getTags(businessId: any) {
    return this.http.get(
      environment.newServerIp + `tag/get?businessId=${businessId}`
    )

  }

  deleteTag(id: any) {
    return this.http.delete(
      environment.newServerIp + `tag/delete?tagId=${id}`
    )
  }

  createIdea(data: any) {
    return this.http.post(
      environment.newServerIp + `idea/create`, data
    )
  }

  getIdeaList(data) {
    return this.http.put(
      environment.newServerIp + `idea/filter`, data
    );
  }

  deleteIdea(id: any) {
    return this.http.delete(
      environment.newServerIp + `idea/delete?ideaId=${id}`
    )
  }

  postSummary(businessId: any) {
    return this.http.get(
      environment.newServerIp + `post/${businessId}/summary`
    )
  }

  disconnectChannel(pageId: any) {
    return this.http.delete(
      environment.newServerIp + `social/${pageId}/remove`
    )
  }
  getPostListForCalendar(startDate: string, endDate: string, postStatus?: string, channel?: string, accountId?: string) {
    const businessId = localStorage.getItem('businessId');

    let params = new HttpParams()
      .set('businessId', businessId || '')
      .set('sDate', startDate)
      .set('eDate', endDate);

    if (postStatus) {
      params = params.set('postStatus', postStatus);
    }
    if (channel) {
      params = params.set('channel', channel);
    }
    if (accountId) {
      params = params.set('accountId', accountId);
    }

    return this.http.post(`${environment.newServerIp}post/calendar`, '', { params });
  }


  deletePost(postId: any) {
    return this.http.delete(
      environment.newServerIp + `post/${postId}/delete`);
  }

  deletePublishedPost(postId: any) {
    return this.http.delete(
      environment.newServerIp + `post/${postId}/delete`
    )
  }

  updateIdeaStatus(ideaId: any, status: any) {
    return this.http.put(
      environment.newServerIp + `idea/${ideaId}/change-group/${status}`, ''
    )
  }

  labelSearch(businessId: any, searchText: any) {
    return this.http.get(
      environment.newServerIp + `tag/${businessId}/search?searchRequest=${searchText}`
    )
  }


  openSnack(message: any, action: any) {
    this.snackbar.open(message, action, { duration: 5000 });
  }

  getLinkedInUserDetailsByLoginCode(sendingPayload) {
    return this.http.put(environment.baseUrl + `admin/api/linkedin/login-code/user-info`, sendingPayload);
  }

  connectSelectedProfileToLinkedIn(profileDetail) {
    return this.http.post(environment.baseUrl + `admin/api/linkedin/profile/connect`, profileDetail)
  }

  getAllIdeaTags(businessId: any) { // userId is UUID
    return this.http.get(environment.newServerIp + `group/${businessId}/list`);
  }
  createIdeaGroup(data: any) {
    return this.http.post(
      environment.newServerIp + `group/create`, data
    )
  }
  editIdeaGroup(statusId: any, newName: any) {
    return this.http.put(
      environment.newServerIp + `group/${statusId}/rename?newName=${newName}`, ''
    )
  }
  deleteIdeaGroup(groupId: any) {
    return this.http.delete(
      environment.newServerIp + `group/${groupId}/delete`
    )
  }
  generateIdea(payload: any) {
    return this.http.post(
      environment.serverIp + `open-ai/integration/suggest/marketing/idea`, payload
    )
  }

  createMessage(payload: any) {
    return this.http.post(environment.newServerIp + `idea/discussion/message`, payload);
  }
  getMessage(ideaId: any) {
    return this.http.get(environment.newServerIp + `idea/discussion/${ideaId}/list`);
  }

  getStaffDetails(staffId: any) {
    return this.http.get(environment.baseUrl + `staff/staff/${staffId}`);
  }

  customizeIdeaSuggestion(text: String, type: String) {
    const apiUrl = environment.serverIp + `open-ai/integration/customize/marketing/idea?type=${type}`;
    return this.http.post(apiUrl, { text: text });
  }

  createCampaign(payload: any) {
    return this.http.post(
      environment.newServerIp + `campaign`, payload
    )
  }

  getAllCampaigns(id: any, data: any) {
    return this.http.put(
      environment.newServerIp + `campaign/${id}/filter`, data
    )
  }

  getIndividualCampaign(id: any) {
    return this.http.get(
      environment.newServerIp + `campaign/${id}/details`
    )
  }

  pauseResumeCampaign(id: any, status: any, data?: any) {
    return this.http.put(
      environment.newServerIp + `campaign/${id}/change-status?status=${status}`, data
    )
  }

  getCampaignPost(bId: any, pageNo: any, size: any, camapignId: any) {
    return this.http.get(
      environment.newServerIp + `post/listing?businessId=${bId}&pageNo=${pageNo}&size=${size}&campaignId=${camapignId}`
    )
  }

  getPrismImages(businessId: any, page: any, pageSize: any, sort: any) {
    return this.http.get(
      environment.prism + `/api/generated/${businessId}?page=${page}&pageSize=${pageSize}&sort=${sort}`
    )
  }

  getDashboardData(businessId: any, startDate: string, endDate: string) {
    return this.http.get(
      environment.newServerIp + `social/${businessId}/flow-overview?startDate=${startDate}&endDate=${endDate}`
    )
  }

  getSuggestedPost(businessName: any, industry: any, subIndustry: any) {
    return this.http.get(
      environment.aiAgentsUrl + `api/v1/business/social-media-parameters/${businessName}?industry=${industry}&sub_industry=${subIndustry}`
    )
  }

  getAiSuggestions(businessName: any, industry: any, subIndustry: any) {
    return this.http.get(
      environment.aiAgentsUrl + `api/v1/business/suggested-prompts/${businessName}?industry=${industry}&sub_industry=${subIndustry}&agent_type=social`
    )
  }

  smmAppConfiguration(businessId: any, appId: any, subAppId: any, action: any) {
    return this.http.put(
      environment.baseUrl + `app/app/opt/sub-app?businessId=${businessId}&appId=${appId}&subAppId=${subAppId}&action=${action}`, {}
    )
  }

  getSocialSettings(businessId: any) {
    return this.http.get(
      environment.baseUrl + `business/business/brand-profile/${businessId}`
    )
  }

  updateSocialSettings(data: any) {
    return this.http.put(
      environment.baseUrl + `business/business/update/brand-profile`, data
    )
  }

  getBusinessKeyBenefits(subIndustryId: any) {
    return this.http.get(
      environment.serverIp + `master/business/sub/industry/${subIndustryId}`
    )
  }

  getPostSettings(businessId: string) {
    return this.http.get(
      environment.newServerIp + `settings/${businessId}`
    )
  }

  updatePostSettings(data: any) {
    return this.http.post(
      environment.newServerIp + `settings`, data
    )
  }

  saveTemplateSettings(businessId: any, data: any) {
    return this.http.put(
      environment.newServerIp + `settings/${businessId}/template`, data
    )
  }

  saveIdeaSettings(businessId: any, data: any) {
    return this.http.put(
      environment.newServerIp + `settings/${businessId}/idea`, data
    )
  }

  saveCampaignSettings(businessId: any, data: any) {
    return this.http.put(
      environment.newServerIp + `settings/${businessId}/campaign`, data
    )
  }
}

